import WeightTile from './weight-tile';

export default WeightTile;
